import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import {createHead} from 'src/components/Seo';
import HomepageTemplate from 'components/Homepage';
const MDXLayout = HomepageTemplate;
export const Head = createHead();
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
export default function MDXContent(props = {}) {
  return _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  });
}
